import AppSystemListResultModelBase from '../_generated/modelBases/app-system-list-result-model-base';

export default class AppSystemListResultModel extends AppSystemListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
